import { NO_VALUE_EDITOR } from '..';
import { useConditionBuilderStoreApi } from '../store';
import { RuleCombinator } from '../types';
import { DEFAULT_RULE } from '../utils';

export function useUpdateRuleField() {
  const store = useConditionBuilderStoreApi();

  return ({ idx, field }: { idx: number; field: string }) => {
    store.setState((state) => {
      const rule = state.condition.rules[idx];
      if (!rule) return;

      if (rule.field === field) return;

      const fieldSetting = store.getState().fieldMap.get(field);

      state.condition.rules[idx] = {
        id: rule.id,
        field,
        operator:
          fieldSetting?.defaultOperator || fieldSetting?.operators?.[0] || DEFAULT_RULE.operator,
        values: fieldSetting?.defaultValues || DEFAULT_RULE.values,
        validationRule: fieldSetting?.validationRule,
      };
    });
  };
}

export function useUpdateRuleCombinator() {
  const store = useConditionBuilderStoreApi();

  return (type: RuleCombinator) => {
    store.setState((state) => {
      state.condition.combinator = type;
    });
  };
}

export function useUpdateRuleOperator() {
  const store = useConditionBuilderStoreApi();

  return ({ idx, operator }: { idx: number; operator?: string }) => {
    store.setState((state) => {
      const rule = state.condition.rules[idx];

      if (!rule) return;

      const newOperator = operator || DEFAULT_RULE.operator;
      rule.operator = newOperator;

      if ((NO_VALUE_EDITOR as string[]).includes(newOperator)) {
        rule.values = DEFAULT_RULE.values;
      }
    });
  };
}

export function useUpdateRuleValue() {
  const store = useConditionBuilderStoreApi();

  return ({ idx, values }: { idx: number; values?: unknown[] }) => {
    store.setState((state) => {
      const rule = state.condition.rules[idx];

      if (!rule) return;

      rule.values = values || DEFAULT_RULE.values;
    });
  };
}
